var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconSvg',_vm._b({attrs:{"viewBox":"0 0 24 48"}},'IconSvg',_vm.$attrs,false),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.175 34.8387L17.0537 36.96L4.79021 24.6966C4.39968 24.306 4.39968 23.6729 4.79021 23.2823L17.0537 11.0189L19.175 13.1402L8.32574 23.9895L19.175 34.8387Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }